export default "__VITE_ASSET__CHK4sdr5__"